import { GenericPaginatedListResponse } from '../main'

export enum ChatAnalysisType {
  GROUP = 'group',
  SITUATIONSHIP = 'situationship',
  DATING = 'dating',
}

export const getChatAnalysisTypeLabel = (type: ChatAnalysisType) => {
  switch (type) {
    case ChatAnalysisType.GROUP:
      return '단톡방 케미'
    case ChatAnalysisType.SITUATIONSHIP:
      return '썸/플러팅'
    case ChatAnalysisType.DATING:
      return '연애 케미'
  }
}

export type ChatAnalysisMember = {
  id: number
  userId: number | null
  name: string
}

export type ChatAnalysisResult = {
  type: ChatAnalysisType
  uuid: string
  name: string
  ownerId: number
  analyzedAt: string
  availableAdsCount: number
  isSelfSelected: boolean
  members: ChatAnalysisMember[]
}

export type ChatAnalysisResultResponse = {
  data: ChatAnalysisResult
}

export type ChatAnalysisListData = {
  type: ChatAnalysisType
  uuid: string
  imageUrl: string
  analyzedAt: string
  availableAdsCount: number // 광고 시청 횟수
  isSelfSelected: boolean // '나' 선택 여부 (선택 안했으면 선택 화면으로 이동)
  name: string
  description: string
  createdAt: string
}

export type ChatAnalysisPaginatedListResponse = GenericPaginatedListResponse & {
  data: { items: ChatAnalysisListData[]; totalCount: number }
}

export type ChatAnalysisMeta = {
  isFree: boolean
  totalAnalysisCount: number
}

export type ChatAnalysisMetaResponse = {
  data: ChatAnalysisMeta
}
